import { createApi } from '@reduxjs/toolkit/query/react';

import { BACKOFFICE_ONLY_CATEGORIES } from '@/config/constants';
import { ProductStrapi } from '@/types/Product';
import { StrapiRealProduct } from '@/types/Strapi';

import { productsAdapter } from '../adapters';
import { generateBaseQuseryWithReAuth } from '../baseQueryReauth';

export const searchApi = createApi({
  reducerPath: 'searchApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({
    useStrapiServer: true,
    basePath: '',
  }),
  tagTypes: ['SearchProducts'],
  endpoints: builder => ({
    getProductsByQuery: builder.query<ProductStrapi[], { query: string; isBackoffice?: boolean; limit?: number }>({
      query: ({ query, limit }) => {
        return {
          url: `/pawtree/search-products-fallback?search=${query}${limit ? '&limit=' + limit : ''}`,
          next: { tags: ['SearchProducts'] },
        };
      },
      providesTags: ['SearchProducts'],
      transformResponse(response: { data: StrapiRealProduct[] }, meta, arg) {
        let data = (response?.data ? productsAdapter(response.data).Products : []).filter(
          p => !p?.attributes?.DisableCartOperations && !!p?.attributes?.publishedAt
        );

        if (!arg.isBackoffice)
          data = data?.filter(
            p =>
              !(
                ((p?.attributes?.Categories as any)?.data as any[])?.length <= BACKOFFICE_ONLY_CATEGORIES.length &&
                ((p?.attributes?.Categories as any)?.data as any[])?.find?.(c =>
                  BACKOFFICE_ONLY_CATEGORIES.includes(`${c?.id}`)
                )
              )
          );

        console.log('Search API called', { query: arg.query, limit: arg.limit, count: data.length }, data);

        return data;
      },
    }),

    searchProductsByQuery: builder.query<ProductStrapi[], { query: string; isBackoffice?: boolean; limit?: number }>({
      query: ({ query, limit }) => {
        return {
          url: `/api/products/shopping-experience/search?search=${query}${limit ? '&limit=' + limit : ''}`,
          next: { tags: ['SearchProducts'] },
        };
      },
      providesTags: ['SearchProducts'],
      transformResponse(response: { data: StrapiRealProduct[] }, meta, arg) {
        let data = (response?.data ? productsAdapter(response.data).Products : []).filter(
          p => !p?.attributes?.DisableCartOperations && !!p?.attributes?.publishedAt
        );

        if (!arg.isBackoffice)
          data = data?.filter(
            p =>
              !(
                ((p?.attributes?.Categories as any)?.data as any[])?.length <= BACKOFFICE_ONLY_CATEGORIES.length &&
                ((p?.attributes?.Categories as any)?.data as any[])?.find?.(c =>
                  BACKOFFICE_ONLY_CATEGORIES.includes(`${c?.id}`)
                )
              )
          );

        console.log('Search API called', { query: arg.query, limit: arg.limit, count: data.length }, data);

        return data;
      },
    }),
  }),
});

export const { useGetProductsByQueryQuery, useSearchProductsByQueryQuery } = searchApi;
